import React, { useEffect } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay animate-cool-fade-in" onClick={onClose}>
      <div 
        className="modal-content animate-cool-slide-up"
        onClick={(e) => e.stopPropagation()} 
      >
        {/* Header */}
        <div className="flex justify-between items-center p-0 relative">
          <h3 
            className="text-white font-medium text-[22px] leading-[24px]"
            style={{
              fontWeight: 500,
              letterSpacing: '-0.275px',
              marginTop: '24px',
              marginLeft: '24px',
              padding: 0
            }}
          >
            {title}
          </h3>
          <button 
            onClick={onClose}
            className="flex items-center justify-center bg-transparent border-none cursor-pointer absolute"
            style={{
              top: '24px',
              right: '24px',
              padding: 0
            }}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path opacity="0.5" d="M22 12.002C22 17.525 17.523 22.002 12 22.002C6.477 22.002 2 17.525 2 12.002C2 6.47895 6.477 2.00195 12 2.00195C17.523 2.00195 22 6.47895 22 12.002Z" fill="white" fillOpacity="0.56"/>
              <path d="M8.96983 8.97113C9.11045 8.83068 9.30108 8.75179 9.49983 8.75179C9.69858 8.75179 9.8892 8.83068 10.0298 8.97113L11.9998 10.9411L13.9698 8.97113C14.0385 8.89744 14.1213 8.83834 14.2133 8.79735C14.3053 8.75636 14.4046 8.73432 14.5053 8.73254C14.606 8.73076 14.706 8.74929 14.7994 8.78701C14.8928 8.82473 14.9776 8.88087 15.0489 8.95209C15.1201 9.02331 15.1762 9.10814 15.214 9.20153C15.2517 9.29492 15.2702 9.39495 15.2684 9.49565C15.2666 9.59636 15.2446 9.69567 15.2036 9.78767C15.1626 9.87967 15.1035 9.96247 15.0298 10.0311L13.0598 12.0011L15.0298 13.9711C15.1623 14.1133 15.2344 14.3014 15.231 14.4957C15.2276 14.69 15.1489 14.8753 15.0114 15.0128C14.874 15.1502 14.6887 15.2289 14.4943 15.2323C14.3 15.2357 14.112 15.1636 13.9698 15.0311L11.9998 13.0611L10.0298 15.0311C9.88765 15.1636 9.69961 15.2357 9.50531 15.2323C9.31101 15.2289 9.12562 15.1502 8.98821 15.0128C8.85079 14.8753 8.77208 14.69 8.76865 14.4957C8.76522 14.3014 8.83735 14.1133 8.96983 13.9711L10.9398 12.0011L8.96983 10.0311C8.82938 9.8905 8.75049 9.69988 8.75049 9.50113C8.75049 9.30238 8.82938 9.11176 8.96983 8.97113Z" fill="white" fillOpacity="0.56"/>
            </svg>
          </button>
        </div>
        
        {/* Content */}
        <div className="">{children}</div>
      </div>
    </div>
  );
};

export default Modal; 